import type { ReactNode } from "react";
import {
  IconArrowsExchange,
  IconBusinessplan,
  IconCalendarCheck,
  IconCalendarEvent,
  IconCash,
  IconFileTypePdf,
  IconKey,
  IconLifebuoy,
  IconLink,
  IconLinkOff,
  IconSearch,
  IconTargetArrow,
  IconUsersGroup,
  IconMailOpened,
  IconHomeQuestion,
  IconBuildingSkyscraper,
} from "@tabler/icons-react";
import type { NotificationType } from "../types";

export function notificationIcon(type: NotificationType, size = 14): ReactNode {
  switch (type) {
    case "NewLead":
      return <IconTargetArrow size={size} />;
    case "ProposalReceived":
    case "ProposalStatusChanged":
      return <IconBusinessplan size={size} />;
    case "ShareInvitationReceived":
    case "ShareInvitationResponded":
      return <IconLink size={size} />;
    case "ShareRevoked":
      return <IconLinkOff size={size} />;
    case "ActivityReminder":
      return <IconCalendarEvent size={size} />;
    case "PaymentConfirmed":
      return <IconCash size={size} />;
    case "SupportTicketReplied":
      return <IconLifebuoy size={size} />;
    case "InspectionReportReady":
    case "ContractMinutaReady":
      return <IconFileTypePdf size={size} />;
    case "PartnerInviteReceived":
    case "PartnerInviteResponded":
      return <IconUsersGroup size={size} />;
    case "AccessAuthorizationResponded":
      return <IconKey size={size} />;
    case "PropertyAvailabilityResponded":
      return <IconCalendarCheck size={size} />;
    case "PropertyReturnResponded":
      return <IconHomeQuestion size={size} />;
    case "OwnerWelcomeViewed":
      return <IconMailOpened size={size} />;
    case "DemandBroadcastReceived":
      return <IconSearch size={size} />;
    case "LaunchInviteReceived":
      return <IconBuildingSkyscraper size={size} />;
    default:
      return <IconArrowsExchange size={size} />;
  }
}

export const notificationIconTint: Record<NotificationType, string> = {
  NewLead: "bg-brand-50 text-brand-600",
  ProposalReceived: "bg-orange-soft text-orange",
  ProposalStatusChanged: "bg-orange-soft text-orange",
  ShareInvitationReceived: "bg-info-soft text-info",
  ShareInvitationResponded: "bg-info-soft text-info",
  ShareRevoked: "bg-danger-soft text-danger-ink",
  ActivityReminder: "bg-warning-soft text-warning",
  PaymentConfirmed: "bg-success-soft text-success",
  SupportTicketReplied: "bg-info-soft text-info",
  InspectionReportReady: "bg-success-soft text-success",
  ContractMinutaReady: "bg-info-soft text-info",
  PartnerInviteReceived: "bg-pink-50 text-pink-600",
  PartnerInviteResponded: "bg-pink-50 text-pink-600",
  AccessAuthorizationResponded: "bg-info-soft text-info",
  PropertyAvailabilityResponded: "bg-brand-50 text-brand-600",
  PropertyReturnResponded: "bg-warning-soft text-warning",
  OwnerWelcomeViewed: "bg-success-soft text-success",
  LaunchInviteReceived: "bg-brand-50 text-brand-600",
  DemandBroadcastReceived: "bg-brand-50 text-brand-600",
};
